export default __webpack_public_path__ + "static/media/close_black.97e60069.svg";